module.exports = __webpack_public_path__ + "img/pagina menu correios login.e2c01d48.png";